import { valueConverter } from 'aurelia';
import { formatMinor } from '@shared/index';

@valueConverter('money')
export class MoneyValueConverter {
  toView(minor: number | undefined | null, precision = 3, symbol = ''): string {
    if (minor === undefined || minor === null || Number.isNaN(minor)) return '-';
    const s = formatMinor(minor, precision);
    return symbol ? `${s} ${symbol}` : s;
  }
}

@valueConverter('mmss')
export class MmssValueConverter {
  toView(ms: number): string {
    const s = Math.max(0, Math.ceil(ms / 1000));
    const m = Math.floor(s / 60);
    return `${m}:${String(s % 60).padStart(2, '0')}`;
  }
}

@valueConverter('ago')
export class AgoValueConverter {
  toView(epochMs: number | undefined): string {
    if (!epochMs) return '';
    const d = Date.now() - epochMs;
    if (d < 60_000) return 'just now';
    if (d < 3_600_000) return `${Math.floor(d / 60_000)} min ago`;
    if (d < 86_400_000) return `${Math.floor(d / 3_600_000)} h ago`;
    return new Date(epochMs).toLocaleDateString();
  }
}

/** Keno ball colour by decade, like the venue screen. */
@valueConverter('decade')
export class DecadeValueConverter {
  toView(n: number): string {
    return `dec-${Math.min(8, Math.ceil(n / 10))}`;
  }
}

@valueConverter('odds')
export class OddsValueConverter {
  toView(o: number): string {
    if (!Number.isFinite(o)) return '-';
    return `1 in ${o >= 100 ? Math.round(o).toLocaleString() : o.toFixed(2)}`;
  }
}

@valueConverter('pct')
export class PctValueConverter {
  toView(p: number, digits = 1): string {
    return `${(p * 100).toFixed(digits)}%`;
  }
}
